@if (projectedPoint()){
    <map-marker [position]="projectedPoint()" [options]="projectedPointCircleOptions()" />
    <map-marker [position]="projectedPoint()" [options]="projectedPointArrowOptions()" />
}